// GLOBAL_GOLD_BADGE= ||CERT_BADGE=premier||MASTER_BADGE= ||SMB_BADGE= ||CUSTOMER_BADGE= ||PROVIDER_BADGE=

const BADGE_SEPARATOR = '||';
const BADGE_NAME_VALUE_SEPARATOR = '=';
const BADGE_GLOBAL_GOLD = 'GLOBAL_GOLD_BADGE';
const BADGE_CERTIFICATION = 'CERT_BADGE';
const BADGE_MASTER = 'MASTER_BADGE';
const BADGE_SMB = 'SMB_BADGE';
const BADGE_CUSTOMER = 'CUSTOMER_BADGE';
const BADGE_PROVIDER = 'PROVIDER_BADGE';
const BADGE_DEVELOPER = 'DEVELOPER_BADGE';
const BADGE_ADVISOR = 'ADVISOR_BADGE';

const KEY_GLOBAL_GOLD_CERTIFICATION = 'globalGoldCertification';
const KEY_CERTIFICATION = 'certification';
const KEY_MASTER = 'master';
const KEY_SMB = 'smb';
const KEY_CUSTOMER = 'customer';
const KEY_PROVIDER = 'provider';
const KEY_DEVELOPER = 'developer';
const KEY_ADVISOR = 'advisor'

const PARTNER_BADGE_NAME_TO_OBJECT_KEY_MAPPING = {
  [BADGE_GLOBAL_GOLD]:   KEY_GLOBAL_GOLD_CERTIFICATION,
  [BADGE_CERTIFICATION]: KEY_CERTIFICATION,
  [BADGE_MASTER]:        KEY_MASTER,
  [BADGE_SMB]:           KEY_SMB,
  [BADGE_CUSTOMER]:      KEY_CUSTOMER,
  [BADGE_PROVIDER]:      KEY_PROVIDER,
  [BADGE_DEVELOPER]:     KEY_DEVELOPER,
  [BADGE_ADVISOR]:       KEY_ADVISOR
};

export default function convertPartnerQualIconsStringToArray(partnerQualIconsString) {
  let partnerQualificationsArray = [];
  if(!!partnerQualIconsString && !!partnerQualIconsString.length && 'string' === typeof partnerQualIconsString) {
    const qualBadges = partnerQualIconsString.split(BADGE_SEPARATOR).map(qualBadgeString => qualBadgeString.trim());
    qualBadges.forEach(
      qualBadge => {
        const qualBadgeAsArray = qualBadge.split(BADGE_NAME_VALUE_SEPARATOR);
        const qualBadgeName = qualBadgeAsArray[0];
        const qualBadgeValue = qualBadgeAsArray[1];
        const roleLevelObject = {
          [PARTNER_BADGE_NAME_TO_OBJECT_KEY_MAPPING[qualBadgeName]] : qualBadgeValue
        };
        partnerQualificationsArray.push(roleLevelObject);
      }
    );
  }
  return partnerQualificationsArray;
}

